import { render, staticRenderFns } from "./manage-currencies.vue?vue&type=template&id=39d79567&scoped=true&"
import script from "./manage-currencies.vue?vue&type=script&lang=js&"
export * from "./manage-currencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d79567",
  null
  
)

export default component.exports